export default "__VITE_ASSET__Cwz7xNeY__"